import useRead from "../useRead";

const useGetAttributes = ({ limit = 10 } = {}) => {
  const initialData = {
    pageNo: 0,
    limit: limit,
    searchQuery: "",
  };

  const handlePageClick = (val) => {
    let pageNo = {
      ...paramsObject,
      pageNo: val.selected,
    };
    setGetListParams(pageNo);
  };

  const handleSearchVal = (e) => {
    let value = e.target.value;
    let copyParams = {
      ...paramsObject,
      searchQuery: value,
      pageNo: 0,
    };
    setGetListParams(copyParams);
  };

  const handleSetLimit = (e) => {
    let value = e.target.value;
    let copyParams = {
      ...paramsObject,
      limit: value,
    };
    setGetListParams(copyParams);
  };

  const { data, paramsObject, setGetListParams } = useRead({
    initialData,
    url: "product/attribute-value/list",
    method: "GET",
  });

  return {
    data,
    handlePageClick,
    handleSearchVal,
    handleSetLimit,
    paramsObject,
  };
};

export default useGetAttributes;
